import { IntroScreen } from '@/screens/mini-games'

export default function () {
  return <IntroScreen />
}
